import MicroModal from 'micromodal';

class Modal {
  constructor() {
    MicroModal.init({
      onShow: (modal) => this.onShow(modal),
      awaitCloseAnimation: true,
    });
  }

  /**
   * Called when the modal is shown.
   * @param {HTMLElement} modal The modal element.
   */
  onShow(modal) {
    // Remove the existing modal to avoid duplicate modals.
    const existingModal = document.querySelector(`#${modal.id}`);
    if (existingModal) existingModal.remove();

    // Teleport the modal to the body to avoid z-index issues.
    document.body.appendChild(modal);
  }
}

new Modal();